import { defineSlotRecipe } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/react/anatomy';

export const selectSlotRecipe = defineSlotRecipe({
	slots: selectAnatomy.keys(),
	base: {
		root: {
			gap: '2'
		},
		label: {
			fontWeight: 'semibold',
			textStyle: 'sm'
		},
		trigger: {
			bg: { base: 'white', _dark: '{colors.neutral.800}' },
			color: { base: '{colors.neutral.800}', _dark: 'white' },
			borderWidth: '1px',
			borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' },
			borderRadius: 'md',
			height: '10',
			_focus: {
				outline: 'none',
				borderColor: { base: '{colors.blue.500} !important', _dark: '{colors.blue.400} !important' },
			},
			_placeholder: {
				color: { base: '{colors.neutral.300}', _dark: '{colors.neutral.500}' },
			},
			_open: {
				borderColor: { base: '{colors.blue.500} !important', _dark: '{colors.blue.400} !important' },
			}
		},
		control: {
			bg: { base: 'white', _dark: '{colors.neutral.800}' },
			borderRadius: 'md',
			borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' },
			h: '10',
		},
		indicator: {
			color: { base: '{colors.neutral.800}', _dark: 'white' }
		},
		content: {
			maxH: '72'
		}
	},
	variants: {
		variant: {
			borderLeftRadiusNone: {
				trigger: {
					borderTopRightRadius: 'md',
					borderBottomRightRadius: 'md',
					borderTopLeftRadius: '0',
					borderBottomLeftRadius: '0',
				}
			},
			borderTransparent: {
				trigger: {
					borderColor: { base: 'transparent', _dark: '{colors.neutral.600}' },
				}
			}
		}
	}
});